import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment'

import { actions as vehiclesActions } from '../../../redux/modules/vehiclesActions'
import { actions as driverActions } from '../../../redux/modules/vehiclesActions'

import { Form, DatePicker, Select } from 'antd'
const FormItem = Form.Item
const Option = Select.Option

const propTypes = {
  editMode: PropTypes.bool.isRequired,
  scheduledDelivery: PropTypes.object.isRequired,
  handleUpdateDelivery: PropTypes.func.isRequired
}

class DeliveryDetails extends Component {
  componentDidUpdate(prevProps) {
    const { editMode } = this.props

    if (prevProps.editMode === true && editMode === false) {
      this.submitForm()
    }
  }

  getSelectedVehicle = value => {
    const vehicles = _.get(this.props, 'vehiclesActions.payload.data')
    const selectedVehicle = vehicles.find(vehicle => vehicle.name === value)
    return selectedVehicle ? +selectedVehicle.id : +value
  }

  getSelectedDriver = value => {
    const drivers = _.get(this.props, 'driverActions.payload.data')
    const selectedDriver = drivers.find(
      driver => `${driver.first_name} ${driver.last_name}` === value
    )
    return selectedDriver ? +selectedDriver.id : +value
  }

  submitForm = () => {
    const { handleUpdateDelivery } = this.props
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.driver_id = this.getSelectedDriver(values.driver_id)
      values.vehicle_id = this.getSelectedVehicle(values.vehicle_id)
      values.scheduled_date = moment(values.scheduled_date).format('YYYY/MM/DD HH:mm:ss')

      handleUpdateDelivery(values)
    })
  }

  vehiclesOptions = () => {
    const vehicles = _.get(this.props, 'vehiclesActions.payload.data')
    if (vehicles) {
      return vehicles.map(vehicle => <Option key={vehicle.id}>{vehicle.name}</Option>)
    }
  }

  driversOptions = () => {
    const drivers = _.get(this.props, 'driverActions.payload.data')
    if (drivers) {
      return drivers.map(driver => (
        <Option key={driver.id}>
          {driver.first_name} {driver.last_name}
        </Option>
      ))
    }
  }

  render() {
    const { editMode, scheduledDelivery } = this.props
    const { getFieldDecorator } = this.props.form
    return (
      <Form layout="vertical">
        <div className="row">
          <div className="col-6">
            <div className="row">
              <div className="col-12">
                <FormItem label="Vehicle Name">
                  {getFieldDecorator('vehicle_id', {
                    rules: [
                      {
                        required: true,
                        message: 'Vehicle cannot be blank.'
                      }
                    ],
                    initialValue: scheduledDelivery.vehicle_name
                  })(
                    <Select
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      disabled={!editMode}
                    >
                      {this.vehiclesOptions()}
                    </Select>
                  )}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <FormItem label="Driver Name">
                  {getFieldDecorator('driver_id', {
                    rules: [
                      {
                        required: true,
                        message: 'Driver cannot be blank.'
                      }
                    ],
                    initialValue: `${scheduledDelivery.driver_first_name} ${
                      scheduledDelivery.driver_last_name
                    }`
                  })(
                    <Select
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      disabled={!editMode}
                    >
                      {this.driversOptions()}
                    </Select>
                  )}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <FormItem label="Scheduled Date">
                  {getFieldDecorator('scheduled_date', {
                    rules: [
                      {
                        required: true,
                        message: 'Scheduled Date cannot be blank.'
                      }
                    ],
                    initialValue: moment.utc(scheduledDelivery.scheduled_date)
                  })(<DatePicker disabled={!editMode} />)}
                </FormItem>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="row">
              <div className="col-6">
                <FormItem label="Created Date">
                  {moment(scheduledDelivery.created_date).format('M/D/YYYY h:mm a')}
                </FormItem>
              </div>
              <div className="col-6">
                <FormItem label="Updated Date">
                  {moment(scheduledDelivery.updated_date).format('M/D/YYYY h:mm a')}
                </FormItem>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <FormItem label="Created By">
                  {scheduledDelivery.created_by_first_name} {scheduledDelivery.created_by_last_name}
                </FormItem>
              </div>
              <div className="col-6">
                <FormItem label="Updated By">
                  {scheduledDelivery.updated_by_first_name} {scheduledDelivery.updated_by_last_name}
                </FormItem>
              </div>
            </div>
          </div>
        </div>
      </Form>
    )
  }
}

const mapStateToProps = ({ vehiclesActions, authentication, driverActions }, ownProps) => ({
  vehiclesActions,
  authentication,
  driverActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, vehiclesActions, driverActions), dispatch)
})

DeliveryDetails.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(DeliveryDetails))
)



// WEBPACK FOOTER //
// ./src/components/drivers/delivery/DeliveryDetails.js